const DislikeIcon = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.4896 2.99987V12.8999L12.8896 20.9999C11.3984 20.9999 10.1896 19.7911 10.1896 18.2999V14.6999H4.78963C4.26155 14.7059 3.75749 14.4796 3.41096 14.0811C3.06442 13.6826 2.91038 13.152 2.98963 12.6299L4.23163 4.52987C4.36622 3.64241 5.1341 2.98973 6.03165 2.99987H16.4896ZM16.4896 2.99987L18.8927 2.99984C19.9471 2.9812 20.8484 3.75485 20.9897 4.79984V11.0999C20.8484 12.1448 19.9471 13.0185 18.8927 12.9999H16.4897L16.4896 2.99987Z"
        stroke="#090914"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DislikeIcon;
